import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-heading-text-wrapper',
  imports: [],
  templateUrl: './heading-text-wrapper.component.html',
  styleUrl: './heading-text-wrapper.component.scss'
})
export class HeadingTextWrapperComponent {
  @Input() headingText: string = 'Welcome to Our Application';
  @Input() bodyText: string = 'This is a sample application to demonstrate the HeadingTextWrapper component.';
  @Input() textIcon?: string | undefined = undefined;
}
